import React from "react"
import {
  MovableCardWrapper,
  CardHeader,
  CardTitle,
  Detail,
} from "react-trello/dist/styles/Base"
import { CheckBox } from "../../Form"
import PhoneContainer from "../../../container/PhoneContainer"
import LaneScrollContext from '../Virtualized/LaneScrollContext'

import "./styles.scss"
import { RiPhoneFill, RiWhatsappFill } from "react-icons/ri"
import ModalAlert from "../../ModalAlert"
import moment from "moment"
import { InfoTooltip } from "../../Tooltip"

export const CardBoard = (props) => {
  const {
    handleSelectedCardOnBoard,
    handleNavigateToProfile,
    selectedCardOnBoard,
    style,
    onClick,
    className,
    id,
    laneId,
    title,
    whatsapp,
    tags,
    generalTag,
    date,
    phone,
    cardDraggable,
    handleRemoveTag,
    scope,
    currentUser,
    email,
    birthday,
    state,
    address,
    city: counties,
    community,
    terms_accepted,
    createdAt,
    lastAcitvity,
    document,
    project,
    projectId,
    event_timestamp
  } = props
  const scrollIndex = React.useContext(LaneScrollContext) || { min: 0, max: Infinity }

  // using the context set in the ScrollableLane we can calculate what to actually render here
  if (props.index < scrollIndex.min || props.index > scrollIndex.max) {
    return null
  }

  const card = {
    id,
    name: title,
    email,
    phone,
    whatsapp,
    birthday,
    state,
    address,
    counties,
    community,
    terms_accepted,
    createdAt,
    lastAcitvity,
    document,
    project,
    projectId,
    event_timestamp,
  }

  return (
    <div className="card-kanban">
      <MovableCardWrapper
        data-id={id}
        onClick={onClick}
        style={style}
        className={className}
        title="">
        <CardHeader>
          <CheckBox
            onChange={(e) => handleSelectedCardOnBoard(e, laneId)}
            value={id}
            checked={selectedCardOnBoard?.some((val) => val?.id === id) || false}
          />
          <CardTitle draggable={cardDraggable}>
            <InfoTooltip
              info={`Ir para o perfil do(a) beneficiário(a) ${title}`}
              children={
                <div
                  className="react-trello-card-title"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleNavigateToProfile(card)}>
                  <strong>{title}</strong>
                </div>
              }
            />

            <div className="react-trello-card-sub">{date}</div>
            {generalTag && generalTag?.assignmentDate && (
              <div className="react-trello-card-sub" title="Data da Atribuição da Tag">
                <strong>Atribuído em:</strong>{" "}
                {moment(generalTag?.assignmentDate).format("DD/MM/YYYY")}
              </div>
            )}
            {phone && (
              <div className="react-trello-card-sub react-trello-card-sub-wpp">
                <RiPhoneFill />
                {phone.split("+")[1]}
              </div>
            )}
            {whatsapp && (
              <div
                className="react-trello-card-sub react-trello-card-sub-wpp"
                onClick={() =>
                  window.open(
                    `https://wa.me/${whatsapp.split("+")[1]}`,
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
                title="Abrir WhatsApp">
                <RiWhatsappFill />
                WhatsApp
              </div>
            )}
          </CardTitle>
          <PhoneContainer
            scope={scope}
            currentUser={currentUser}
            value={phone}
            name={title}
            isCard={true}
            {...{ props }}
          />
          {/* {showDeleteButton && <DeleteButton onClick={onDelete} />} */}
        </CardHeader>
        <Detail>
          <div className="tag-container">
            {tags &&
              tags.map((tag) => (
                <div
                  className="tag-lane-card"
                  key={tag.id}
                  onClick={() =>
                    tag.projectId !== "" &&
                    ModalAlert.danger({
                      title: "Deseja remover esta tag?",
                      text: "Obs: se você remover esta tag, ela ainda poderá aparecer em outros cards.",
                      confirmLabel: "Confirmar",
                      onConfirm: () => {
                        handleRemoveTag(tag.idLinked)
                      },
                    })
                  }>
                  {" "}
                  <span style={{ color: tag.color, backgroundColor: tag?.bgcolor }}>
                    {tag.title} {tag.projectId !== "" && <span>x</span>}
                  </span>
                </div>
              ))}
          </div>
        </Detail>
      </MovableCardWrapper>
    </div>
  )
}
